import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { BASE_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';
import { RouteRecordRaw } from 'vue-router';

const routes: LocalizedRoutes = {
  de: { path: `${BASE_PATH['de']}/login/callback` },
  en: { path: `${BASE_PATH['en']}/login/callback` },
  fr: { path: `${BASE_PATH['fr']}/login/callback` },
  it: { path: `${BASE_PATH['it']}/login/callback` },
};

const Component = () => import('@/pages/Login/Login.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.Login);

export default localizedRouteConfig;
